import { Route, Switch } from "react-router-dom";
import ScrollToTop from "Shared/navigation/scroll-to-top";
import * as pages from "Pages/index";
import AuthorizedRoute from "Shared/navigation/authorized-route";
import { useImbox } from "Shared/util/custom-hooks";
import { BrandName } from "Shared/util/types";
import useUserContext from "Contexts/user-context";
import useBrandContext from 'Contexts/brand-context';

const Main = () => {
    const { brandData } = useBrandContext();
    const { user, loaded } = useUserContext();
    useImbox();

    const isAdmin = loaded && user.activeCompany.role.isAdmin;

    return (
        <ScrollToTop>
            <Switch>
                <Route exact path="/" component={pages.LandingPage} />
                <Route
                    path="/invoices/:id"
                    component={pages.InvoiceDetailsPage}
                />
                <Route
                    path="/invoice-groups/:id"
                    component={pages.InvoiceGroupPage}
                />
                <Route
                    path="/deposition-groups/:id"
                    component={pages.DepositionGroupPage}
                />
                <Route
                    path="/transactions/export"
                    component={pages.ExportTransactionsPage}
                />
                <Route
                    path="/transactions"
                    component={pages.TransactionsPage}
                />
                <Route path="/payments" component={pages.PaymentsPage} />
                <Route
                    path="/invoices-credit"
                    component={pages.InvoicesCreditPage}
                />
                <Route
                    path="/invoices-deducted"
                    component={pages.InvoicesDeductedPage}
                />
                <Route
                    path="/invoices-payed"
                    component={pages.InvoicesPayedPage}
                />
                <Route
                    path="/invoices-receivables"
                    component={pages.InvoicesReceivablesPage}
                />
                <Route path="/depositions" component={pages.DepositionsPage} />
                <Route path="/ledger" component={pages.LedgerPage} />
                <Route
                    path="/customers/:debtorId"
                    component={pages.DebtorDetailsPage}
                />
                <Route path="/customers" component={pages.DebtorsPage} />
                <Route
                    path="/historical-ledger"
                    component={pages.HistoricalLedgerPage}
                />
                <Route
                    path="/search-result"
                    component={pages.SearchResultPage}
                />
                <Route path="/price" component={pages.PricePage} />
                <Route
                    path="/business-loans"
                    component={pages.BusinessLoansPage}
                />
                <Route
                    path="/invoice-integration"
                    component={pages.InvoiceIntegrationPage}
                />
                <AuthorizedRoute
                    authorized={isAdmin}
                    path="/manage-users"
                    component={pages.ManageUsersPage}
                />
                <Route
                    path="/sales-methods/acconomy-setup"
                    component={pages.AcconomySetupPage}
                />
                <Route
                    path="/sales-methods/fortnox-setup"
                    component={pages.FortnoxSetupPage}
                />
                <Route
                    path="/sales-methods/manual-setup"
                    component={pages.ManualSetupPage}
                />
                <Route
                    path="/sales-methods"
                    component={pages.SalesMethodsPage}
                />
                <Route path="/company-settings/kyc" component={pages.KycPage} />
                <AuthorizedRoute
                    authorized={isAdmin}
                    path="/company-settings/annual-kyc"
                    component={pages.AnnualKycFollowUpPage}
                />
                <AuthorizedRoute
                    authorized={isAdmin && brandData?.name !== BrandName.FinanceLink}
                    path="/company-settings/payout-information"
                    component={pages.PayoutInformationPage}
                />
                <Route
                    path="/company-settings"
                    component={pages.CompanySettingsPage}
                />
                <Route component={pages.NotFoundPage} />
            </Switch>
        </ScrollToTop>
    );
};

export default Main;
